function getDoorDistanceFromRight(action) {
  return action.unit.size[0] - action.doorPosition - 0.5 * action.doorWidth;
}
export {
  getDoorDistanceFromRight
};
//# sourceMappingURL=index211.js.map
